import { Component, OnInit } from '@angular/core';
import { ImpersonationService } from '../../service/impersonation.service';

@Component({
    selector: 'nio-impersonation-banner',
    templateUrl: './impersonation-banner.component.html',
    styleUrl: './impersonation-banner.component.scss',
    standalone: false
})
export class ImpersonationBannerComponent implements OnInit {
  constructor(public imp: ImpersonationService) {}
  ngOnInit(): void {}
}
